import React from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';

const useColorfulTextStyles = makeStyles({
  content: {
    display: 'flex',
    alignItems: 'center',
    '@media (forced-colors: none)': {
      backgroundImage: 'linear-gradient(135deg, #3D07D5 0%, #213AD5 45.05%, #0078D4 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
      backgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      color: 'transparent',
    },
  },
});

interface IColorfulTextProps {
  className?: string;
  children: React.ReactNode;
}

export const ColorfulText: React.FC<IColorfulTextProps> = React.memo((props) => {
  const styles = useColorfulTextStyles();

  return (
    <div className={mergeClasses(styles.content, props.className, 'inline-copilot-colorful-text')}>
      {props.children}
    </div>
  );
});
